import { useQuery } from '@tanstack/react-query';
import { queryKeys, uuidRegEx } from '@utils/consts';
import { queryFetch } from '@services/api';
import { ApiError } from '@root/globalTypes';
import { useQueryParams } from '@hooks/queryParams';
import {
  InventoryLocationItemsRespSuccess,
  InventoryLocationProps,
} from '@services/inventory/types';
import { parseCustomItems } from '@services/inventory/helpers';

export const useGetInventoryRequestedLocation = ({
  preview,
  location,
  customItems,
}: InventoryLocationProps) => {
  const {
    params: { routeId },
    parseParams,
  } = useQueryParams();

  const { type, locationId, locationType } = preview;
  const [pickUpLocationId, pickUpLocationType] = [location?.locationId, location?.locationType];

  const queryParams = parseParams(
    {
      routeId,
      locationId,
      locationType,
      pickUpLocationId,
      pickUpLocationType,
      pickUpCustomItems: parseCustomItems(customItems),
    },
    { arrayFormat: 'bracket' },
  );

  const { data, error, isPending } = useQuery<InventoryLocationItemsRespSuccess, ApiError>({
    queryKey: [...queryKeys.inventoryRequestedLocation, locationId, queryParams],
    queryFn: () =>
      queryFetch({
        url: `routes/requested/location_inventory${queryParams}`,
      }),
    placeholderData: (previousData, previousQuery) =>
      previousQuery?.queryKey.includes(locationId)
        ? (previousData as InventoryLocationItemsRespSuccess)
        : undefined,
    enabled:
      type === 'requested' && Boolean(locationId && uuidRegEx.test(locationId) && locationType),
  });

  return {
    data,
    error,
    isLoading:
      isPending &&
      type === 'requested' &&
      Boolean(locationId && uuidRegEx.test(locationId) && locationType),
  };
};
